





















































import { defineComponent } from "@vue/composition-api"
import useFetcher from '@/ts/functions/composition/useFetcher';

export default defineComponent({

  name : "Sidebar",

  props: {
    place: Object,
    default: () => {}
  },

  setup(props, {root}) {

    var { entity: user, loading } = useFetcher("auth/GET_USER_DATA");

    const placeNavItems = [
        {
          title: root.$options.filters!.capitalize(root.$i18n.t("calendar")),
          path: "/place/" + root.$route.params.id + "/calendar",
          icon: "event"
        },
        {
          title: root.$options.filters!.capitalize(root.$i18n.t("notes")),
          path: "/place/" + root.$route.params.id + "/notes",
          icon: "description"
        },
        {
          title: root.$options.filters!.capitalize(root.$i18n.t("projects")),
          path: "/place/" + root.$route.params.id + "/projects",
          icon: "handyman"
        },
        {
          title: root.$options.filters!.capitalize(root.$i18n.t("events")),
          path: "/place/" + root.$route.params.id + "/events",
          icon: "star"
        }
      ];

    return{
      user,
      placeNavItems
    }

  }
});
